import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Form,
    Tooltip,
    Input,
    Popconfirm,
    Select,
} from "antd";
import {
    UnorderedListOutlined,
    EditFilled,
    DeleteFilled,
    ToolFilled
} from "@ant-design/icons";
import { convertColumns } from "../../../../utils/columnconverter";
import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import { useTranslation } from "react-i18next";
import { whiteSpace, noWhitespace } from "../../../../utils/rules";
import { FloatLabel } from 'primereact/floatlabel';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
const { Option } = Select;

const Users = (props) => {
    const mainUrl = "User"
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [users, setUsers] = useState([]);
    const [spin, setSpin] = useState(false);
    const [editing, setEditing] = useState(null);
    const [reset, setReset] = useState(null)
    const [roles, setRoles] = useState([]);
    const [message, setMessage] = useState(null)
    const cols = [
        { key: "index", value: "#", con: true },
        { key: "userName", value: t("name"), con: true },
        { key: "image", value: "Şəkil", con: true },
        { key: "id", value: "", con: true },
    ];
    const nameInput = useRef();
    const { notify } = props;

    const columns = [
        {
            title: "#",
            key: "1",
            dataIndex: "index",
            width: 80,
        },
        {
            title: "Ad",
            dataIndex: "fullName",
            key: "10"
        },
        {
            title: "İstifadəçi adı",
            dataIndex: "username",
            key: "10"
        },
        {
            title: "Səlahiyyəti",
            dataIndex: "roleName",
            key: "roleName",
            render: (value) => {
                let style = {};

                if (value === "Admin") {
                    style = {
                        background: "#FEF2F2",
                        color: "#DC2626",
                        border: "1px solid #FCA5A5",
                    };
                } else if (value === "Inspector") {
                    style = {
                        background: "#F5F3FF",
                        color: "#7C3AED",
                        border: "1px solid #C4B5FD",
                    };
                } else if (value === "Organization") {
                    style = {
                        background: "#F8FAFC",
                        color: "#475569",
                        border: "1px solid #CBD5E1",
                    };
                }

                return (
                    <span
                        style={{
                            ...style,
                            padding: "2px 8px",
                            borderRadius: "999px",
                            fontSize: "11px",
                            fontWeight: 500,
                            lineHeight: "16px",
                            display: "inline-block",
                        }}
                    >
                        {value}
                    </span>
                );
            },
        },
        {
            title: "Əməliyyatlar",
            key: "3",
            dataIndex: "id",
            width: 30,
            render: (i) => {
                return (
                    <div className="flex flex-end">
                        <Popconfirm
                            placement="topRight"
                            title={t("areYouSure")}
                            onConfirm={() => deleteUser(i)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <Tooltip className="ml-5" title={t("delete")}>
                                <Button className="border-none" type="text" shape="circle">
                                    <DeleteFilled />
                                </Button>
                            </Tooltip>
                        </Popconfirm>
                        <Tooltip className="ml-5" title={t("edit")} placement="topRight">
                            <Button
                                className="border-none"
                                type="text"
                                shape="circle"
                                onClick={() => setEditingUser(i)}
                            >
                                <EditFilled />
                            </Button>
                        </Tooltip>
                        <Tooltip className="ml-5" title={'Şifrəni yenilə'} placement="topRight">
                            <Button
                                className="border-none"
                                type="text"
                                shape="circle"
                                onClick={() => {
                                    setReset(i);
                                    setEditing(null)
                                }}
                            >
                                <ToolFilled />
                            </Button>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const setEditingUser = async (i) => {
        setReset(false);
        setEditing(i);
        await aictia.get(`${mainUrl}/${i}`).then((res) => {
            let obj = {};
            obj['FullName'] = res.data.fullName;
            obj['roleId'] = res.data.roleId;
            // setActive(names.is_active === 1)
            form.setFieldsValue(obj);
        });
    };

    const deleteUser = async (i) => {
        await aictia

            .delete(`${mainUrl}/${i}`)
            .then((res) => {
                notify("", true);
                getUsers();
            })
            .catch((err) => {
                notify(err.response, false);
            });
    };


    const cancelEditing = () => {
        setEditing(null);
        setReset(false)
        form.resetFields();
    };
    const savePosition = async (values) => {
        let obj = {
            fullName: values.FullName,
            userName: values.UserName,
            password: values.Password,
            roleId: values.roleId
        };
        if (!editing) {
            await aictia
                .post(mainUrl, obj)
                .then((res) => {
                    notify("", true);
                    getUsers();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        }
        else {
            obj.id = editing;
            await aictia
                .put(`${mainUrl}/${editing}`, obj)
                .then((res) => {
                    notify("", true);
                    getUsers();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        }

    };

    const getUsers = async () => {
        setSpin(true);
        await aictia.get(mainUrl, { params: { per_page: 20000 } }).then((res) => {
            setSpin(false);
            setUsers(
                res.data.map((p, index) => {
                    return {
                        key: index + 1,
                        ...p,
                        index: index + 1,
                        // name: p.locales.find((l) => {
                        //     return l.local === localStorage.getItem("locale");
                        // }).name,
                    };
                })
            );
        });
    };

    const getRoles = async () => {
        await aictia.get("Role").then((res) => {
            setRoles(
                res.data
            );
        }
        );
    };
    const resetPassword = async (values) => {
        if (values.Password !== values.repetitivePassword) {
            setMessage("Şifrələr uyğun gəlmir");
            return;
        }
        let obj = {
            password: values.Password,
            repetitivePassword: values.repetitivePassword,
            id: reset
        };
        await aictia

            .put(`${mainUrl}/ResetPassword/${reset}`, obj)
            .then((res) => {
                notify("", true);
                setMessage(null)
                getUsers();
                cancelEditing();
            })
            .catch((err) => {
                notify(err.response, false);
            });
    };


    useEffect(() => {
        getUsers();
        getRoles();
    }, [t]);

    ;


    return (
        <Row gutter={[10, 10]} className="pl-1">
            <Col xs={24}>
                <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
                    <span
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 12,
                            background: "#eff6ff",
                            color: "#0c82f4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                            marginTop: 5,
                        }}
                    >
                        <UnorderedListOutlined className="f-20" />
                    </span>
                    <div>
                        <span className="f-20 bold">{t("users")}</span>
                        <p className="text-[11px] text-slate-450 font-medium">{t("usersSub")}</p>
                    </div>
                </div>
            </Col>
            {/* <Col lg={12} xs={24}>
                <Table
                    loading={spin}
                    size="small"
                    className="bg-white animated fadeInLeft"
                    columns={columns}
                    dataSource={convertColumns(users, cols)}
                    pagination={{
                        pageSize: 10,
                        current_page: 1,
                        total: users.length,
                    }}
                />
            </Col> */}
            <Col lg={12} xs={24}>
                <Table
                    loading={spin}
                    size="small"
                    bordered={false}
                    rowKey="id"
                    className="animated fadeInLeft"
                    style={{
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 1px 2px rgba(15,23,42,.05)",
                    }}
                    columns={columns.map((col) => ({
                        ...col,
                        onHeaderCell: () => ({
                            style: {
                                background: "#f8fafc",
                                color: "#94a3b8",
                                fontSize: "10px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: ".05em",
                                borderBottom: "1px solid #e2e8f0",
                                padding: "8px 12px",
                            },
                        }),
                        onCell: () => ({
                            style: {
                                fontSize: "12px",
                                color: "#334155",
                                padding: "8px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                fontWeight: 500,
                            },
                        }),
                    }))}
                    components={{
                        header: {
                            cell: ({ children, ...restProps }) => (
                                <th
                                    {...restProps}
                                    style={{
                                        background: "#e5e7eb",
                                        color: "#828e9e",
                                        height: 56,
                                        padding: "12px 12px",
                                        fontSize: 11,
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        borderBottom: "1px solid #e2e8f0",
                                    }}
                                >
                                    {children}
                                </th>
                            ),
                        },
                    }}
                    dataSource={convertColumns(users, cols)}
                    pagination={{
                        pageSize: 10,
                        current: 1,
                        total: users.length,
                        size: "small",
                        showSizeChanger: false,
                        style: {
                            margin: "16px",
                        },
                    }}
                />
            </Col>
            <Col lg={12} xs={24}>
                <Card title={t("addTo")} className={"animated fadeInRight administrator "} style={{ borderRadius: '20px' }}>
                    {
                        !reset ?
                            <Form layout="vertical" onFinish={savePosition} form={form}>
                                <div className="form-lang mb-20">
                                    <FloatLabel>
                                        <Form.Item
                                            name={'FullName'}
                                            validateTrigger="onChange"
                                            // getValueFromEvent={(event, editor) => {
                                            //     const dat = editor.getData();
                                            //     return dat;
                                            // }}
                                            rules={[noWhitespace(t("inputError"))]}
                                        >
                                            <InputText ref={nameInput} className="w-full" id="name" style={{ borderRadius: '12px' }} />
                                        </Form.Item>
                                        <label htmlFor="FullName">{t('Ad, soyad, ata adı')}</label>
                                    </FloatLabel>
                                </div>
                                {
                                    !editing &&
                                    <div className="form-lang mb-20">
                                        <FloatLabel>
                                            <Form.Item
                                                name={'UserName'}
                                                validateTrigger="onChange"
                                                // getValueFromEvent={(event, editor) => {
                                                //     const dat = editor.getData();
                                                //     return dat;
                                                // }}
                                                rules={[noWhitespace(t("inputError"))]}
                                            >
                                                <InputText ref={nameInput} className="w-full" id="UserName" readOnly
                                                    onFocus={(e) => e.target.removeAttribute('readonly')} style={{ borderRadius: '12px' }} />
                                            </Form.Item>
                                            <label htmlFor="UserName">{t('İstifadəçi adı')}</label>
                                        </FloatLabel>

                                    </div>
                                }
                                {
                                    !editing &&
                                    <div className="form-lang mb-20">
                                        <FloatLabel>
                                            <Form.Item
                                                validateTrigger="onChange"
                                                name="Password"
                                                rules={[
                                                    whiteSpace(t("addPasswordError")),
                                                    {
                                                        min: 6,
                                                        message: t("minimumPasswordError"),
                                                    },
                                                ]}

                                            >
                                                <Password toggleMask id="Password" feedback={false} className="w-full" inputClassName="w-full" inputStyle={{ borderRadius: "12px", }} />
                                            </Form.Item>
                                            <label htmlFor="Password">{t('Şifrə')}</label>

                                            {message && <div className="text-danger">{message}</div>}
                                        </FloatLabel>
                                    </div>
                                }


                                <div className="form-lang">
                                    <FloatLabel>
                                        <Form.Item
                                            name={'roleId'}
                                            validateTrigger="onChange"
                                            // getValueFromEvent={(event, editor) => {
                                            //     const dat = editor.getData();
                                            //     return dat;
                                            // }}
                                            rules={[noWhitespace(t("inputError"))]}
                                            style={{ borderRadius: '12px' }}
                                            className=" taskkk"
                                        >
                                            <Select id='roleId' className="custom-select">
                                                {roles.map((p) => {
                                                    return (
                                                        <Option key={p.id} value={p.id}>
                                                            {p.name}
                                                        </Option>
                                                    );
                                                }
                                                )}
                                            </Select>
                                        </Form.Item>
                                        <label htmlFor="roleId">{t('Səlahiyyəti')}</label>
                                    </FloatLabel>

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: 15,
                                        width: "100%",
                                    }}
                                >
                                    <Button
                                        onClick={cancelEditing}
                                        style={{
                                            height: 36,
                                            padding: "0 16px",
                                            borderRadius: 10,
                                            background: "#f8fafc",
                                            border: "1px solid #e2e8f0",
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: "#334155",
                                        }}
                                    >
                                        {t("cancel")}
                                    </Button>

                                    <Button
                                        htmlType="submit"
                                        style={{
                                            height: 36,
                                            padding: "0 16px",
                                            borderRadius: 10,
                                            background: "#f8fafc",
                                            border: "1px solid #e2e8f0",
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: "#334155",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {t("save")}
                                    </Button>
                                </div>
                            </Form>
                            :
                            <Form layout="vertical" onFinish={resetPassword} form={form}>
                                <div className="form-lang mb-20">
                                    <FloatLabel>

                                        <Form.Item
                                            className="mb-5"
                                            validateTrigger="onChange"
                                            name="Password"
                                            rules={[
                                                whiteSpace(t("addPasswordError")),
                                                {
                                                    min: 6,
                                                    message: t("minimumPasswordError"),
                                                },
                                            ]}
                                        >
                                            <Password autoComplete="off" feedback={false} toggleMask className="w-full" inputClassName="w-full" />
                                        </Form.Item>
                                        <label htmlFor="Password">{t('Şifrə')}</label>

                                        {message && <div className="text-danger">{message}</div>}
                                    </FloatLabel>
                                </div>
                                <div className="form-lang">
                                    <FloatLabel>

                                        <Form.Item
                                            className="mb-5"
                                            validateTrigger="onChange"
                                            name="repetitivePassword"
                                            rules={[
                                                whiteSpace(t("addPasswordError")),
                                                {
                                                    min: 6,
                                                    message: t("minimumPasswordError"),
                                                },
                                            ]}
                                        >
                                            <Password autoComplete="off" feedback={false} toggleMask className="w-full" inputClassName="w-full" />
                                        </Form.Item>
                                        <label htmlFor="repetitivePassword">{t('Təkrar şifrə')}</label>
                                        {message && <div className="text-danger">{message}</div>}
                                    </FloatLabel>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: 15,
                                        width: "100%",
                                    }}
                                >
                                    <Button
                                        onClick={cancelEditing}
                                        style={{
                                            height: 36,
                                            padding: "0 16px",
                                            borderRadius: 10,
                                            background: "#f8fafc",
                                            border: "1px solid #e2e8f0",
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: "#334155",
                                        }}
                                    >
                                        {t("cancel")}
                                    </Button>

                                    <Button
                                        htmlType="submit"
                                        style={{
                                            height: 36,
                                            padding: "0 16px",
                                            borderRadius: 10,
                                            background: "#f8fafc",
                                            border: "1px solid #e2e8f0",
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: "#334155",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {t("save")}
                                    </Button>
                                </div>
                            </Form>
                    }

                </Card>
            </Col>
        </Row>
    );
};

const mapStateToProps = ({ langs }) => {
    return {
        langs: langs,
    };
};

export default connect(mapStateToProps, { notify })(Users);
